/* eslint-disable max-len */
import api from 'utils/api'

export const checkPasswordExpiryRequest = async (payload: any) =>
    await api.post('/cps/v1/verifyPasswordExpiry', payload)

export const createNewPasswordRequest = async (payload: any) => await api.post('/cps/v1/updatePassword', payload)
